'use strict';

import {ListCtrl} from '../esfasi/listctrl.js';
import {IrregularitiesNewDialogCtrl} from './irregularitiesnewdialogctrl.js';
import {irregularityModel} from '../../models/irregularitymodel.js';

export class IrregularitiesIndexCtrl extends ListCtrl
{
	$mdDialog;
	
	$scope;
	
	classif;
	
	storageNames = {
		query: 'IrregularitiesListCtrlQuery'
	};
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService, $mdDialog){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.$scope = $scope;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = jsDataService.get('cfgClassif');
	}
	
	createNew(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', IrregularitiesNewDialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'irregularities/new_irregularity_dialog.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
			}
		}).then((results) => {
			if(this.jsDataService.get('cfgCreateUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgCreateUrl'),
					method: 'POST',
					data: {
						project: results.id,
					}
				}).then((response) => {
					this.loadData();
				}, () => {});
			}
		}, (results) => {
		});
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new irregularityModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof irregularityModel){
			return row.getValue(col);
		}
		return row[col];
	}
}